import _ from 'lodash'
import Vue from 'vue'
import Settings from '@/config/Settings'

export default {
  namespaced: true,
  state: {
    initialized: false,
    users: {},
    sync_time: { time: 0, utc: 0 },
    start_movie: false,
    user_leave: 0,
    master_leave: 0,
    subtitles: 0,
  },
  mutations:{
    'SOCKET_userConnected'(state, data) {

      console.log('SOCKET_userConnected ');
      console.log(data);
      // state.users[data.user] = data.room
    },
    'SOCKET_setUserStatus'(state, data) {
      state.initialized = true
    },
    'SOCKET_syncTime'(state, time) {
      state.sync_time = time
    },
    'SOCKET_startProjection'(state, data) {

      console.log('SOCKET_startProjection ');
      console.log(data);

      state.start_movie = data.used
      state.subtitles = data.subtitles;
      // state.user_leave = null
    },
    'SOCKET_userLeaveRoom'(state) {
      state.user_leave += 1
      state.start_movie = false
    },
    'SOCKET_masterLeaveRoom'(state) {
      state.master_leave += 1

    },
  },
  getters: {
    initialized: state => state.initialized,
    users: state => state.users,
    sync_time: state => state.sync_time,
    start_movie: state => state.start_movie,
    user_leave: state => state.user_leave,
    master_leave: state => state.master_leave,
    subtitles: state => state.subtitles,
  }
}
